import template from './adpTypeahead.html';
import controller from './adpTypeahead.controller';
import './adpTypeahead.less';

let adpTypeaheadComponent = {
  restrict: 'E',
  bindings: {
    options: '<',
  },
  template,
  controller
};

export default adpTypeaheadComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpTypeahead/adpTypeahead.component.js